<template>
    <section>
        <div class="ss-breadcrumb">
            <div class="container-hts">
                <ul class="margin-0 p-0">
                    <li><router-link to="/soan-tai-lieu">Soạn tài liệu</router-link></li>
                    <li><router-link to="/soan-tai-lieu">Bài tập/bài kiểm tra</router-link></li>
                    <li><router-link to="">{{ nameLecture }}</router-link></li>
                </ul>
            </div>
        </div>
        <div class="container">
            <div class="name-leson mt-3">
                <h4>
                    <strong>{{ nameLecture }}</strong>
                </h4>
            </div>
            <b-tabs pills>
                <b-tab @click="handleOnChangeTab(tabContent)" title="Nội dung" :active="tabActive == tabContent">
                    <TabContentExcersiceAssign v-if="tabActive == tabContent" />
                </b-tab>
                <b-tab @click="handleOnChangeTab(tabListClassSchool)" title="Danh sách lớp được giao"
                    :active="tabActive == tabListClassSchool">
                    <TabListClassSchoolAssign v-if="tabActive == tabListClassSchool" />
                </b-tab>

            </b-tabs>
        </div>
    </section>
</template>
<script>
import TabContentExcersiceAssign from './_components/TabContentExcersiceAssign'
import TabListClassSchoolAssign from './_components/TabListClassSchoolAssign'
export default {
    components: {
        TabContentExcersiceAssign,
        TabListClassSchoolAssign
    },
    data() {
        return {
            tabActive: 1,
            tabContent: 1,
            tabListClassSchool: 2,
            nameLecture: ''
        }
    },
    mounted() {
        this.nameLecture = this.$router.history.current.query.name
    },
    methods: {
        handleOnChangeTab(tab) {
            this.tabActive = tab
        }
    }
}
</script>